import PropTypes from "prop-types";

import numberFormat from "common/source-function/numberFormat";

import styles from "./Index.module.scss";

const AuditingTab = ({
  setAuditingIndexType,
  revenue,
  revenueMin,
  revenueMax,
  auditingIndexType,
  auditingService,
  setRevenue,
}) => {
  const auditingType = auditingService?.types[auditingIndexType];

  return (
    <>
      <div className="mb-6 flex flex-wrap items-center justify-center gap-x-1 gap-y-2 pl-3">
        <span className="whitespace-nowrap">Up to</span>
        {auditingIndexType === 0 ? (
          <input
            id="upto-input"
            className={`h-8 rounded-full border border-bbc-neutral-600 text-center outline-none ${
              styles.inputNumber
            } ${
              auditingType?.format?.unit && auditingType?.format?.unit !== ""
                ? "w-20"
                : "w-32"
            }`}
            type="number"
            value={revenue}
            onChange={(e) => {
              if (
                e.target.value.length === 2 &&
                (e.target.value[1] != "." || e.target.value[1] != ",") &&
                e.target.value[0] == 0
              ) {
                document.getElementById("upto-input").value = parseFloat(
                  e.target.value
                );
              }
              setRevenue(e.target.value);
            }}
          />
        ) : (
          <input
            className={`h-8 rounded-full border border-bbc-neutral-600 text-center outline-none ${
              styles.inputNumber
            } ${
              auditingType?.format?.unit && auditingType?.format?.unit !== ""
                ? "w-20"
                : "w-32"
            }`}
            type="text"
            value={numberFormat(revenue)}
            onChange={(e) => {
              setRevenue(e.target.value);
            }}
          />
        )}
        <span>{auditingType?.format?.unit}</span>
        <select
          value={`${auditingIndexType}`}
          onChange={(e) => setAuditingIndexType(parseInt(e.target.value, 10))}
          className="h-8 w-20 rounded-full border border-bbc-neutral-600 py-0 pr-7 outline-none"
        >
          {auditingService?.types.map((value, index) => (
            <option value={index} key={index}>
              {value.name}
            </option>
          ))}
        </select>
        <span className="whitespace-nowrap">Annual revenue</span>
      </div>
      <div className="lg:px-6">
        <input
          className={`form-input mb-4 h-1 w-full appearance-none rounded-full bg-bbc-primary focus:shadow-none focus:outline-0 focus:ring-0 ${styles.sfc_slider}`}
          type="range"
          min={revenueMin}
          max={revenueMax}
          step={auditingType?.revenue?.step || 1}
          value={revenue}
          onChange={(e) => setRevenue(e.target.value)}
        />
        <div className="mb-8 flex justify-between">
          <span>
            {numberFormat(revenueMin)} {auditingType?.format?.unit || ""}
          </span>
          <span>
            {" "}
            {auditingType?.rounded
              ? parseFloat(numberFormat(revenueMax)).toFixed(2)
              : numberFormat(revenueMax)}{" "}
            {auditingType?.format?.unit || ""}
          </span>
        </div>
      </div>
    </>
  );
};

export default AuditingTab;

AuditingTab.propTypes = {
  setAuditingIndexType: PropTypes.func,
  revenue: PropTypes.number,
  revenueMin: PropTypes.number,
  revenueMax: PropTypes.number,
  auditingIndexType: PropTypes.number,
  auditingService: PropTypes.object,
  setRevenue: PropTypes.func,
};

AuditingTab.defaultProps = {
  setAuditingIndexType: () => {},
  revenue: 0,
  revenueMin: 0,
  revenueMax: 0,
  auditingIndexType: 0,
  auditingService: {},
  setRevenue: () => {},
};
